// VideoCarousel.jsx
import React, { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import './carousel.css'; // Custom CSS for styling
import ArrowNew from "../../assets/Common/send.png"
import HandGif from "../../assets/carousel/swipe_new.gif"
import { Pause, Play, X } from 'react-bootstrap-icons';
import { isMobile } from 'react-device-detect';
import { useSearchParams } from 'react-router-dom';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid';
import "react-phone-number-input/style.css";
import PhoneInput, { isValidPhoneNumber, parsePhoneNumber } from "react-phone-number-input";
import flags from "react-phone-number-input/flags";
import { submitLeadForm } from "../../redux/actions/micrositeAction";
import useMicroSiteEncrypt from "../CustomHook/useMicroSiteEncrypt";
import { useDispatch, useSelector } from "react-redux";
import { ExclamationCircleFill } from "react-bootstrap-icons";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

const CategoryPdfCarousel = ({ activeData, colors }) => {
  const dispatch = useDispatch();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const videoRef = useRef(null);
  // const [video, setVideo] = useState("");
  const [searchParams] = useSearchParams();
  const temp_id = searchParams.get('template_id');
  const [isPlaying, setIsPlaying] = useState(false);
  const sliderRef = useRef(null);

  // Ensure slider recalculates/refreshes when showcase images change
  useEffect(() => {
    if (activeData?.showcasepdfImage && sliderRef.current) {
      // small delay to allow DOM update, then reset to first slide and trigger resize
      const t = setTimeout(() => {
        try {
          sliderRef.current?.slickGoTo(0);
        } catch (e) {
          // ignore
        }
        // force window resize to let slick recalculate dimensions
        window.dispatchEvent(new Event('resize'));
      }, 80);
      return () => clearTimeout(t);
    }
  }, [activeData?.showcasepdfImage]);
  
  // Dialog and form states
  const [showDialog, setShowDialog] = useState(false);
  const [checkFlag, setCheckFlag] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [countryCode, setCountryCode] = useState("+91");
  const [mobile, setMobile] = useState("");
  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [message, setMessage] = useState("");
  
  // Redux selectors
  const { microSiteEncrypt } = useMicroSiteEncrypt();
  const url_data = useSelector((state) => state.microsite?.url_data);
  const current_flow = useSelector((state) => state.microsite?.home_data?.flow);
  const customize_fields = useSelector(
    (state) => state.microsite?.home_data?.customization
  );

  useEffect(() => {
    if (videoRef?.current) {
      videoRef?.current?.pause();
      videoRef.current.currentTime = 0;  // Reset video time
      setIsPlaying(false);               // Reset play/pause state
    }
  }, [activeData]);
  
  const handlePlayPause = () => {
    if (isPlaying) {
      videoRef?.current?.pause();
      // a.pause();
    } else {
      videoRef?.current?.play();
      // a.play();
    }
    setIsPlaying(!isPlaying);
  };  

  const fileType = activeData?.pdf_file_detail ? JSON.parse(activeData.pdf_file_detail) : {orientation: "P"};

  const settings = {
    dots: false,
    dotsClass: "slick-dots",
    infinite: false,
    speed: 500,
    slidesToShow: fileType?.orientation == "L" ? 2 : 3.5,
    slidesToScroll: 1,
    draggable: true,
    swipe: true,
    responsive: [
      {
        breakpoint: 768, // This is the breakpoint for mobile devices
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };
  
  console.log("activeData", activeData);
  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    const headerOffset = isMobile ? 80:50; // Adjust based on the header height
    const elementPosition = section?.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  };

  const getYouTubeEmbedUrl = (url) => {
    try {
      const ytRegex = /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/))([\w-]{11})/;
      const match = url.match(ytRegex);
      return match ? `https://www.youtube.com/embed/${match[1]}` : null;
    } catch {
      return null;
    }
  };

  // Form handling functions
  const captcha_key =
    window.location.origin.includes("spdevmfp") ||
    window.location.origin.includes("localhost")
      ? "6LfunNgbAAAAAEM0X3hcwSBYKJwIqHmmInfz0uFK"
      : window.location.origin.includes("sppreprod") ||
      window.location.origin.includes("sptestmfp")
      ? "6Ldeg6YaAAAAAAZqU7AQ_j-lG4LcnwP4jfNFiCJJ"
      : "6Lf9fqoaAAAAAH8JhnTg9gLI3KsYKmR2tdCRVg8i";

  const handleCountryChange = (value) => {
    if (value) {
      try {
        const phoneNumberObj = parsePhoneNumber(value);
        const newCountryCode = '+' + phoneNumberObj?.countryCallingCode;
        setCountryCode(newCountryCode);
      } catch (error) {
        console.error('Invalid phone number', error);
      }
    } else {
      setCountryCode('');
    }
  };

  const submitForm = async () => {
    // Validation checks
    if (name == "" && customize_fields?.top_contact?.name?.validation == "required") {
      setNameError(true);
      return;
    } else if ((mobile == "" || mobileError == true) && customize_fields?.top_contact?.phone?.validation == "required") {
      setMobileError(true);
      return;
    } else if ((email == "" && customize_fields?.top_contact?.email?.validation == "required") || emailError == true ) {
      setEmailError(true);
      return;
    } else {
      setNameError(false);
      setMobileError(false);
      setEmailError(false);
    }

    // Get fresh recaptcha token for lead form. executeRecaptcha() comes from
    // the GoogleReCaptchaProvider mounted in App.js -- it reuses the widget
    // that provider already rendered, instead of calling grecaptcha.execute()
    // with the site key directly, which throws "Invalid site key or not
    // loaded in api.js" because the provider's script loads in explicit
    // widget mode, not the implicit render=<sitekey> mode that call assumes.
    let freshRecaptchaToken = "";
    if (executeRecaptcha) {
      try {
        freshRecaptchaToken = await executeRecaptcha("lead_form");
      } catch (err) {
        console.error("reCAPTCHA execute failed:", err);
      }
    }
    if (!freshRecaptchaToken) {
      return;
    }

    let payload = {
      fullname: name,
      phoneNo: mobile ? `${countryCode}-${mobile.replace(countryCode, '')}` : "",
      emailId: email,
      message: message,
      recaptcha_token: freshRecaptchaToken,
      url: url_data,
      content: "Brochure",
      camp_id: activeData?.template_id
    }

    const generateToken = async () => {
      const token = await microSiteEncrypt(payload);
      if (token && token !== "") {
        dispatch(
          submitLeadForm(
            token,
            payload,
            "Let's Discuss",
            current_flow,
            onSuccess
          )
        );
      }
    };

    generateToken();
  };

  const onSuccess = () => {
    setName("");
    setEmail("");
    setMobile("");
    setCountryCode("+91");
    setCheckFlag(false);
    setShowDialog(false);
  // Download PDF if content_file exists
  if (activeData?.content_file) {
    // Create temporary link element
    const link = document.createElement('a');
    link.href = activeData.content_file;
    link.setAttribute('download', ''); // This will keep original filename
    link.setAttribute('target', '_blank');
    
    // Programmatically click the link to trigger download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  };

  const handleButtonClick = () => {
    if (activeData?.cta_buttonLabel) {
      setShowDialog(true);
    } else {
      scrollToSection("section4");
    }
  };

  
  return (
    <>
   
    <div id='section-7' style={{ backgroundColor: `${colors?.primary}10` }} className={`${isMobile ? "" : (activeData?.showcasepdfImage?.length < 4 ? "product-carousel":"")} px-8 max-sm:px-0 max-sm:py-4 py-8 rounded-tl-none max-sm:rounded-t-none rounded-3xl`}>
        {activeData?.cs_mode == "Brochure" ? (
            <div className='broucher-pdf relative'>
              <button
              onClick={() => sliderRef.current?.slickPrev()}
              className="absolute left-0 top-1/2 ml-3 transform -translate-y-1/2 z-[2] p-1 bg-white rounded-full shadow-md hover:bg-gray-100"
            >
              <ChevronLeftIcon className="w-6 h-6 text-gray-700" />
            </button>
            <Slider {...settings} ref={sliderRef} className='w-full py-4 max-sm:pb-0 max-sm:pt-0 m-auto'>
              {activeData?.showcasepdfImage?.map((item, p_index) => {
                if (!item) return null;
                const embedUrl = getYouTubeEmbedUrl(item);
                const isVideo = /\.(mp4|webm|ogg)(\?.*)?$/i.test(item);
                return (
                  <div className='relative' key={p_index}>
                    {embedUrl ? (
                      <iframe
                        width="560"
                        height="315"
                        src={embedUrl}
                        title={`embed-${p_index}`}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                        className="px-4 w-full h-auto"
                      />
                    ) : isVideo ? (
                      <video controls className={`${fileType?.orientation == "L" ? "md:h-[350px]" : ""} px-4 w-full`}>
                        <source src={item} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    ) : (
                      <img src={item} alt={`media-${p_index}`} className={`${fileType?.orientation == "L" ? "md:h-[350px]" : ""} px-4`}/>
                    )}
                    {(p_index == 0 && isMobile) && (
                      <div className='absolute showSwipe w-[100px] pb-2 pt-1 rounded-l-full right-4 px-4 top-1/3 opacity-80 bg-gray-50'>
                        <img src={HandGif} alt='gif' />
                      </div>
                    )}
                  </div>
                )
              })}
            </Slider>
            {activeData?.showcaseLoading && (
              <div className="absolute inset-0 z-50 flex items-center justify-center bg-white/70">
                <div className="text-sm font-medium text-gray-700">Loading...</div>
              </div>
            )}
            <button
              onClick={() => sliderRef.current?.slickNext()}
              className="absolute right-0 top-1/2 transform -translate-y-1/2 z-[2] p-1 bg-white rounded-full shadow-md hover:bg-gray-100"
            >
              <ChevronRightIcon className="w-6 h-6 text-gray-700" />
            </button>
          </div>
        ) : (
          <div className="carousel-container max-sm:px-4 video-carousel w-[70%] max-sm:w-full max-sm:ml-0 max-sm:mr-auto mx-auto max-sm:my-8 my-8 mt-4 max-sm:mt-0">
            <div className="video-slide">
              {(() => {
                const embedUrl = getYouTubeEmbedUrl(activeData?.content_file);
                if (embedUrl) {
                  return (
                    <iframe 
                      width="560" 
                      height="315" 
                      src={embedUrl}
                      title="YouTube video player" 
                      frameBorder="0" 
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                      referrerPolicy="strict-origin-when-cross-origin" 
                      allowFullScreen></iframe>
                  );
                } else if (activeData?.content_file) {
                  return (
                    <>
                      <video ref={videoRef} key={activeData?.content_file} autoPlay loop>
                        <source src={activeData?.content_file} type="video/mp4" />
                      </video>
                      <button className="play-pause-btn bg-white" onClick={() => handlePlayPause()}>
                        {isPlaying ? <Pause /> : <Play />}
                      </button>
                    </>
                  );
                }
                return null;
              })()}
            </div>
          </div>
        )}
        <div className='flex max-sm:block items-center mt-8 max-sm:mt-4 text-left'>
            <div className='w-[80%] max-sm:w-full space-y-4 px-4'>
                <h1 
                  className='text-xl not-italic font-semibold capitalize leading-[120%]'
                  style={{ color: colors?.primary }}
                >
                  {activeData?.title}
                </h1>
                <p 
                  className='text-sm not-italic font-normal leading-[132%] text-gray-00'
                >
                  {activeData?.description}
                </p>
            </div>
            <div className='w-[20%] max-sm:w-full max-sm:mt-4 flex justify-center'>
              <span 
                onClick={handleButtonClick} 
                className="inline-flex cursor-pointer border text-[#fff] my-auto py-1.5 px-4 text-sm not-italic font-semibold shadow-sm rounded-[49px] border-solid border-[#F0F0F0] gap-2"
                style={{ backgroundColor: colors?.secondary }}
              >
                {activeData?.cta_buttonLabel || "Know more"}
                <img src={ArrowNew} alt='arrow'/>      
              </span>
            </div>  
        </div>      

        {/* Dialog Modal */}
        {showDialog && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-3xl max-w-md w-full max-h-[90vh] overflow-y-auto">
              <div className="p-6">
                {/* Header */}
                <div className="flex justify-between items-center mb-6">
                  <h2 className="text-xl font-semibold" style={{ color: colors?.primary }}>
                    {activeData?.cta_buttonLabel || "Contact Us"}
                  </h2>
                  <button
                    onClick={() => setShowDialog(false)}
                    className="text-gray-500 hover:text-gray-700"
                  >
                    <X size={24} />
                  </button>
                </div>
                

                {/* Lead Form */}
                <div className="space-y-4">
                  <div>
                    <div className="relative">
                      <input
                        placeholder={`Your Name ${customize_fields?.top_contact?.name?.validation == "required" ? "*":""}`}                      
                        id="first-name"
                        name="first-name"
                        type="text"
                        autoComplete="given-name"
                        className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset custom_ring_color sm:text-sm sm:leading-6"
                        value={name}
                        onChange={(e) => {  
                          const regex = /^[a-zA-Z ]*$/;
                          if (regex.test(e.target.value)) {
                            setName(e.target.value);
                          }  
                          if (e.target.value != "") {
                            setNameError(false);
                          }
                        }}
                      />
                      {nameError != false && <ExclamationCircleFill title="Enter a name" className="text-xs absolute top-1/2 text-[#D62049] -translate-y-1/2 right-1.5"/>}
                    </div>
                  </div>

                  <div>
                    <div className="relative country-customize">
                      <PhoneInput
                        flags={flags}
                        placeholder=""
                        value={mobile}
                        defaultCountry="IN"
                        limitMaxLength
                        countryCallingCodeEditable={false}
                        international={true}                            
                        onChange={(e) => {
                          if (e) {
                            setMobile(e);
                            handleCountryChange(e);
                            if (isValidPhoneNumber(e)) {
                              setMobileError(false); 
                            } else {
                              setMobileError(true); 
                            }
                          } else {
                            setMobile("");
                            setCountryCode("");
                            setMobileError(false); 
                          }
                        }}
                      />
                      {mobileError != false && <ExclamationCircleFill title="Enter a valid mobile number" className="text-xs absolute top-1/2 text-[#D62049] -translate-y-1/2 right-1.5"/>}
                    </div>
                  </div>    

                  <div>
                    <div className="relative">
                      <input
                        placeholder={`Email ID ${customize_fields?.top_contact?.email?.validation == "required" ? " *":""}`} 
                        id="email"
                        name="email"
                        type="email"
                        autoComplete="email"
                        className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6 custom_ring_color"
                        value={email}
                        onChange={(e) => {
                          const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;                       
                          if (regex.test(e.target.value) || e.target.value == "") {
                            setEmailError(false);
                          } else {
                            setEmailError(true);
                          }   
                          setEmail(e.target.value)
                        }}
                      />
                      {emailError != false && <ExclamationCircleFill title="Enter a valid email" className="text-xs absolute top-1/2 text-[#D62049] -translate-y-1/2 right-1.5"/>}
                    </div>
                  </div>

                  <div>
                    <textarea
                      placeholder="Message"
                      id="message"
                      name="message"
                      className="block w-full h-[120px] resize-none rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6 custom_ring_color"
                      value={message}
                      onChange={(e)=>{setMessage(e.target.value)}}
                    />
                  </div>

                  <div className="text-left text-sm leading-3">
                    <span className="text-[#000] text-[9px] not-italic font-normal">
                      I understand that I would be contacted with regards to this request placed and consent for the same in spite of being registered with the National Customer Preference Registry (NCPR) with TRAI. I am aware that there is a de-registration facility (for not receiving such calls) which I may avail if required in future.
                    </span>
                  </div>

                  <div className="flex items-center justify-between">
                    <button
                      onClick={submitForm}
                      type="submit"
                      style={{
                        backgroundColor: colors?.secondary,
                      }}
                      className="rounded-full items-center flex gap-2 w-28 justify-center py-1.5 text-center text-sm font-semibold text-white shadow-sm hover:opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                    >
                      <span className="pt-0.5">Submit</span>
                      <img src={ArrowNew} alt='arrow'/>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
    </div>
    </>
  
  );
};

export default CategoryPdfCarousel;